import { css } from 'styled-components'

export const VerticalWrapperStyles = css<{ withBorder?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0px 32px;
`
